import { BaseGQLService } from '../../common/services/BaseGQLService';
import { UserMapper } from '../mappers/UserMapper';
import { User } from '../models/User';

export const CURRENT_USER_QUERY = `
{
  viewer {
    id
    name
    preferredName
    level
    roles
    origin
    organization {
      id
    }
  }
}
`;

export class UserStateService extends BaseGQLService {
  private readonly mapper = new UserMapper();

  async getUser(): Promise<User> {
    return this.query(CURRENT_USER_QUERY, {}, (data) => this.mapper.mapGQLModel(data.viewer));
  }
}
